import React from 'react'
import './Chat.css'
const Sidebar = () => {
  return (
    <div className='sidebar'>Sidebar </div>
  )
}

export default Sidebar
